import { TAccount } from "@/api/v1_0";
import { useStore } from "@/store";
import { observer } from "mobx-react-lite";
import { FunctionComponent, ReactElement, useMemo } from "react";
import { Debt } from "./_dependencies";
import { IDebtsProps } from "./types";

export const Debts: FunctionComponent<IDebtsProps> = observer(
  (props: IDebtsProps): ReactElement<IDebtsProps> => {
    const { addAccount, closeAccount, openAccount, ...restProps } = props;
    const store = useStore();
    const debts: Array<TAccount> = useMemo(
      () =>
        [...store.wallet.debts.values()].map((incomeSource) => ({
          ...incomeSource,
          balance:
            store.operations.accounts.get(incomeSource.uuid)?.amount || 0,
        })),
      [store.wallet.accounts, store.operations.accounts]
    );

    return (
      <div className="contentBox marginBottom whiteBlockBg">
        <div className="contentBoxHeader">
          <h3>Долги</h3>
          {false && (
            <a href="#" className="link" onClick={addAccount}>
              Добавить
            </a>
          )}
        </div>
        <div className="row">
          {debts.map((debt) => (
            <Debt key={debt.uuid} debt={debt} onPress={openAccount} />
          ))}
        </div>
      </div>
    );
  }
);
